import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import Modal from '@mui/material/Modal'
import Stack from '@mui/material/Stack'
import { useAtomValue, useSetAtom } from 'jotai'
import { useEffect } from 'react'
import { loaderTrackingState, forceCompleteLoader } from '../stores/loader-tracking.store'

const LOADER_TIMEOUT_MS = 6000 // Force complete after 6 seconds

const LoaderTracking = () => {
    const { progress, isInitialLoadComplete } = useAtomValue(loaderTrackingState)
    const forceComplete = useSetAtom(forceCompleteLoader)

    // Fallback: force complete after timeout to prevent indefinite loading
    useEffect(() => {
        if (isInitialLoadComplete) return

        const timeoutId = setTimeout(() => {
            console.log('[GLIC2027 LoaderTracking] Timeout reached, forcing completion')
            forceComplete()
        }, LOADER_TIMEOUT_MS)

        return () => clearTimeout(timeoutId)
    }, [isInitialLoadComplete, forceComplete])

    // Don't show modal if initial load is complete
    if (isInitialLoadComplete) {
        return null
    }

    return (
        <Modal
            open={!isInitialLoadComplete}
            aria-labelledby="loader-tracking-modal"
            aria-describedby="initial-load-progress"
            disableEscapeKeyDown
            disableAutoFocus
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10000
            }}>
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(204, 222, 239, 0.95)', // Match GLIC2027 theme
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                <Stack
                    alignItems="center"
                    gap="24px"
                    sx={{
                        backgroundColor: 'transparent',
                        padding: '48px',
                        borderRadius: '16px',
                        boxShadow: 'none',
                        minWidth: '320px',
                        maxWidth: '400px',
                        width: '100%'
                    }}>
                    {/* Linear Progress Bar */}
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress
                            variant="determinate"
                            value={progress}
                            sx={{
                                height: 8,
                                borderRadius: 4,
                                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                '& .MuiLinearProgress-bar': {
                                    borderRadius: 4,
                                    backgroundColor: 'primary.main',
                                    transition: 'transform 0.3s ease'
                                }
                            }}
                        />
                    </Box>
                </Stack>
            </Box>
        </Modal>
    )
}

export default LoaderTracking
